export const APP_CONSTS = {
    CLEAR_JUNCTION_STATUS: {
        CREATED: 'created',
        CANCELLED: 'canceled',
        PENDING: 'pending',
        SETTLED: 'settled',
        DECLINED: 'declined',
    },
    TRANSACTION_STATUS: {
        REQUEST: 'REQUEST',
        REJECT: 'REJECT',
        REJECTED: 'REJECTED',
        PENDING: 'PENDING',
        CLEAR_JUNCTION_PENDING: 'CLEAR_JUNCTION_PENDING',
        CONFIRMED: 'CONFIRMED',
        CANCELLED: 'CANCELLED',
        CANCEL: 'CANCEL',
        FAILED: 'FAILED',
        MAIL: 'MAIL',
        COMPLETED: 'COMPLETED',
        APPROVED: 'APPROVED',
        EXCHANGE_PENDING : 'EXCHANGE_PENDING'
    },
    TRANSACTION_TYPE: {
        DEPOSIT: 'Deposits',
        WITHDRAWAL: 'Withdrawal',
        TRADE: 'Trade',
        CREATE_WALLET: 'CreateWallet',
        CREATE_WALLET_NEW_USER: 'CreateWalletNewUser',
    } ,
    DEPOSIT_TRANSACTION_STATUS:{
        REQUEST: 'REQUEST',
        FAILED: 'FAILED',
        COMPLETED: 'COMPLETED',
        APPROVED: 'APPROVED',
        CLEAR_JUNCTION_PENDING: 'CLEAR_JUNCTION_PENDING',
    }
}


// WEBPACK FOOTER //
// ./src/app/consts/app.consts.ts